import { render } from "./JjigaeBody.vue?vue&type=template&id=9a315e24&scoped=true"
import script from "./JjigaeBody.vue?vue&type=script&lang=js"
export * from "./JjigaeBody.vue?vue&type=script&lang=js"

import "./JjigaeBody.vue?vue&type=style&index=0&id=9a315e24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a315e24"]])

export default __exports__